import React from 'react';
import PropTypes from 'prop-types';
import Social from '../social/social';

function FranchiseIntro(props) {
  return (
    <div className="franchise-intro">
      <Social {...props.social} />
      <div className="franchise-intro__col--4">
        <img src={props.poster} alt={props.title} />
      </div>
      <div className="franchise-intro__col--6">
        <h1 className="franchise-intro__title">{props.title}</h1>
        <p
          className="franchise-intro__desc"
          dangerouslySetInnerHTML={{ __html: props.desc }}
        />
      </div>
    </div>
  );
}

FranchiseIntro.defaultProps = {
  poster: '',
  title: '',
  desc: '',
  social: {}
};

FranchiseIntro.propTypes = {
  poster: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  social: PropTypes.shape({})
};

export default FranchiseIntro;



// WEBPACK FOOTER //
// ./src/views/components/franchise_intro/franchise_intro.js